import { render, staticRenderFns } from "./business-order-lot-new.vue?vue&type=template&id=2c2e1725&"
import script from "./business-order-lot-new.vue?vue&type=script&lang=js&"
export * from "./business-order-lot-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports